import axios from "@/utils/request";

//获取我的色区
export function sexAreaList(data) {
  return axios.get(`/media/sexArea/check/list`, {
    params: data
  });
}